import type { PaymentProcessorKind, PaymentStatus } from '../generated/graphql'
import { getEnvironment } from './getEnvironment'

export const formatTimestamp = (timestamp?: Date | string | null): string => {
  if (!timestamp) return '-'
  const date = new Date(timestamp)
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short',
    hour12: false,
  })
}

export const formatStatus = (status?: PaymentStatus | string | null): string => {
  if (!status) return '-'
  return status.replace(/_/g, ' ')
}

export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount / 100)
}

export const getRoutableUrl = (paymentProcessorKind?: PaymentProcessorKind | null) => {
  if (!paymentProcessorKind) return ''
  const environment = getEnvironment()
  const isProduction = environment === 'production'

  if (isProduction) {
    const baseUrl =
      paymentProcessorKind === 'ROUTABLE_CA' ? 'https://veho-california.routablehq.com' : 'https://veho.routablehq.com'
    return `${baseUrl}`
  }

  // Sandbox/non-production URLs
  const baseUrl =
    paymentProcessorKind === 'ROUTABLE_CA'
      ? 'https://veho-second.routable-sandbox.com'
      : 'https://veho.routable-sandbox.com'
  return `${baseUrl}`
}
